import React from "react";
import "./home.css";
import Fade from "react-reveal/Fade";
import { usePortfolioData } from "../../hooks/usePortfolioData";

const Home = () => {
  const { data, loading } = usePortfolioData();

  if (loading || !data) {
    return (
      <div className="home-container">
        <div className="home-text">Loading...</div>
      </div>
    );
  }

  const { home, personal } = data;

  return (
    <div className="home-container">
      <div className="home-text">
        <Fade delay={200}>
          <div className="small-home-heading">{home.greeting}</div>
        </Fade>
        <Fade delay={350}>
          <div className="big-home-heading">
            {home.name} <span className="fs">.</span>
          </div>
        </Fade>

        <Fade delay={450}>
          {" "}
          <div className="big-home-heading2">{home.tagline}</div>
        </Fade>
        <Fade delay={600}>
          <div className="home-subtext">{home.description}</div>
        </Fade>
      </div>
      <Fade delay={800}>
        <a className="home-contact" href={`mailto:${personal.email}`}>
          {home.ctaText}
        </a>
      </Fade>
    </div>
  );
};

export default Home;
